import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { RedPointDirective } from '@core/components/red-points/red-point/red-point.directive';

import { ERedPointsEvents } from '@store/models';
import { EContentPanelRoute } from 'lingo2-models';
import { AbstractPane } from '../../models/abstract-pane';

@Component({
  selector: 'app-widget-news',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, RedPointDirective, RouterLinkActive, RouterLink],
  templateUrl: './widget-news.component.html',
  styleUrls: ['./widget-news.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetNewsComponent extends AbstractPane implements OnInit {
  public menus = [
    { title: 'menu-widget.list.lessons', link: '/feed' },
    { title: 'menu-widget.list.publications', link: '/people-news' },
    { title: 'menu-widget.list.classrooms', link: '/classroom-news' },
    // { title: 'menu-widget.list.homework', link: '/main' },
    { title: 'menu-widget.list.schools', link: '/school-news' },
    { title: 'menu-widget.list.comments', link: '/comments' },
  ];

  ngOnInit() {}

  public redPointEvent(menu: string): ERedPointsEvents {
    switch (menu) {
      case '/comments':
        return ERedPointsEvents.content_comment;
      case String(EContentPanelRoute['my-classes/classrooms']):
      default:
        return null;
    }
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  public trackByFn(index) {
    return index;
  }
}
